import { render } from "./AdTariff.vue?vue&type=template&id=85cded5e&scoped=true"
import script from "./AdTariff.vue?vue&type=script&lang=js"
export * from "./AdTariff.vue?vue&type=script&lang=js"

import "./AdTariff.vue?vue&type=style&index=0&id=85cded5e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85cded5e"]])

export default __exports__